import React from 'react';

const EffectThree = ({ className = '', title = '' }) => {
  return (
    <svg className={className} width="41" height="17" viewBox="0 0 41 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title lang="en">{title}</title>
      <path d="M0 15.1379C14.9739 15.1379 9.62609 1.86206 20.5 1.86206C31.3739 1.86206 26.0261 15.1379 41 15.1379" stroke="#FCEE21" strokeWidth="2" strokeMiterlimit="10" strokeLinejoin="round"/>
    </svg>
  )
};

export default EffectThree;
